<template>
  <div class="footer footerBackground mainFooter">
    <div class="d-flex justify-content-between pt-3">
      <div class="px-5 footer_content">
        <img
          height="auto"
          class="mb-3"
          src="../assets/images/logo/logo_footer.svg"
          width="81px"
        />
        <p>สำนักงานพัฒนาเศรษฐกิจจากฐานชีวภาพ (องค์การมหาชน)</p>
        <p>
          ศูนย์ราชการเฉลิมพระเกียรติ ๘๐ พรรษา ๕ ธันวาคม ๒๕๕๐ <br />
          อาคารรัฐประศาสนภักดี ชั้น9 เลขที่ 120 หมู่ที่ 3 <br />
          ถนนแจ้งวัฒนะ แขวงทุ่งสองห้อง เขตหลักสี่ กรุงเทพฯ 10210
        </p>

        <p>
          Tel : (66) 2141 7800 <br />
          Fax : (66) 2143 920
        </p>
      </div>
    </div>
    <div style="position: relative;">
      <img
        style="position: absolute; right: 0; bottom: 0"
        src="../assets/images/background/footer-image.png"
        alt="logo-footer"
      />
    </div>
    <div style="background: #000000" class="px-5 py-3 footer_content">© 2021 ALL RIGHTS RESERVED</div>
  </div>
</template>
<script>
export default {
  name: "mainFooter",
};
</script>
<style lang="scss">
.footerBackground {
  background-color: #333333;
  color: white;
  text-align: left;
}

#mainFooter p {
  padding-bottom: 10px;
  margin-bottom: 0;
}

.footer_content {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
}
</style>
